import { render } from "./RIReservations.vue?vue&type=template&id=a25db7d2&scoped=true"
import script from "./RIReservations.vue?vue&type=script&lang=js"
export * from "./RIReservations.vue?vue&type=script&lang=js"

import "./RIReservations.vue?vue&type=style&index=0&id=a25db7d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25db7d2"]])

export default __exports__